<template>
  <div class="register-wrapper">
    <div class="register-container">
      <div style="text-align: center; margin-bottom: 1rem;">
        <img src="/images/logo.png" alt="愿毕达logo" 
             style="width: 100px; height: 100px; border-radius: 50%; 
             object-fit: contain; background-color: #fff;">
      </div>
      <h2>愿毕达高考志愿填报系统注册</h2>
      <div v-if="error" class="error">{{ error }}</div>
      <form @submit.prevent="register">
        <div class="form-group">
          <label for="username">手机号</label>
          <input type="tel" id="username" v-model="username" placeholder="请输入手机号" required pattern="[0-9]{11}" title="请输入有效的11位手机号">
        </div>
        <div class="form-group">
          <label for="password1">密码</label>
          <input type="password" id="password1" v-model="password1" required>
        </div>
        <div class="form-group">
          <label for="password2">确认密码</label>
          <input type="password" id="password2" v-model="password2" required>
        </div>
        <div class="form-group">
          <label for="gaokaoYear">高考年份 <span style="color: red;">*</span></label>
          <select id="gaokaoYear" v-model="gaokaoYear" class="form-select" required>
            <option value="">请选择高考年份</option>
            <option v-for="year in availableYears" :key="year" :value="year">{{ year }}年</option>
          </select>
          <p class="hint-text">注：高考年份一旦设置将不能修改，请谨慎选择（必填）</p>
        </div>
        <button type="submit" class="btn">注册</button>
      </form>
      <div class="link">
        已有账号？<a href="#" @click.prevent="$router.push('/login')">立即登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';  // Import axios
import { getCookie } from '@/utils'


export default {
  data() {
    return {
      username: '',
      password1: '',
      password2: '',
      error: '',
      csrfToken: '',  // Add csrfToken field
      gaokaoYear: '',
      availableYears: []
    };
  },
  mounted() {
    // Get CSRF token on component mount
    this.csrfToken = getCookie('csrftoken');
    
    // 生成可用年份列表（当前年份到未来5年）
    const currentYear = new Date().getFullYear();
    this.availableYears = [];
    const startYear = currentYear;
    const endYear = currentYear + 5;
    
    // 生成从startYear到endYear的年份列表
    for (let year = startYear; year <= endYear; year++) {
      this.availableYears.push(year);
    }
  },
  methods: {
    async register() {
      if (this.password1 !== this.password2) {
        this.error = '两次输入的密码不一致';
        return;
      }
      
      // 验证高考年份是否已选择
      if (!this.gaokaoYear) {
        this.error = '请选择高考年份';
        return;
      }
      
      try {
        const response = await axios.post('/api/register/', {  // Fixed: absolute path with api/
          username: this.username,
          password1: this.password1,
          password2: this.password2,
          gaokao_year: parseInt(this.gaokaoYear)
        }, {
          // withCredentials: true,  // Include credentials
          // headers: {
          //   'Content-Type': 'application/json',
          //   'X-Csrftoken': this.csrfToken  // Include CSRF token
          // },
          // credentials: 'include',  // 确保发送cookie
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data.success) {
          // Registration successful, redirect to login
          this.$message.success('注册成功！请登录。');
          this.$router.push('/login');
        } else {
          this.error = response.data.error || '注册失败，请稍后重试';
        }
      } catch (err) {
        console.error('注册错误:', err);
        // 解析服务器返回的错误信息
        if (err.response && err.response.data && err.response.data.error) {
          // 提取具体的错误信息，去掉数据库错误的包装
          let errorMsg = err.response.data.error;
          if (errorMsg.includes("Duplicate entry")) {
            this.error = "该手机号已注册，请使用其他手机号";
          } else {
            this.error = errorMsg;
          }
        } else {
          this.error = '注册时发生错误，请稍后重试';
        }
      }
    },
    //     // 添加 getCookie 方法实现
    // getCookie(name) {
    //   let cookieValue = null;
    //   if (document.cookie && document.cookie !== '') {
    //     const cookies = document.cookie.split(';');
    //     for (let i = 0; i < cookies.length; i++) {
    //       const cookie = cookies[i].trim();
    //       if (cookie.substring(0, name.length + 1) === (name + '=')) {
    //         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
    //         break;
    //       }
    //     }
    //   }
    //   return cookieValue;
    // },
  }
};
</script>

<style scoped>
.register-wrapper {
  /* 使用flex布局实现垂直和水平居中 */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh; /* 确保占满整个视口高度 */
  background-color: #f5f5f5; /* 设置背景色 */
}

.register-container {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 300px; /* 增加宽度 */
  text-align: center; /* 文本居中 */
}

h2 {
  margin-bottom: 1.5rem;
  color: #67c23a;
  white-space: normal;
}

.form-group {
  margin-bottom: 1rem;
  text-align: left; /* 表单文本左对齐 */
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

input, select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.hint-text {
  font-size: 0.8rem;
  color: #666;
  margin-top: 0.25rem;
}

.btn {
  width: 100%;
  padding: 0.75rem;
  background-color: #67c23a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.btn:hover {
  background-color: #85ce61;
}

.error {
  color: #f56c6c;
  margin-bottom: 1rem;
}

.link {
  margin-top: 1rem;
}
</style>